/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import Swal from 'sweetalert2'
import { Modal, Button } from 'react-bootstrap'
import { postRequestOptions, getRequestOptions } from '../helpers/Fetchwrapper'
import validationErrorMsg from '../helpers/ValidationErrorMsg'
import Spinner from 'react-bootstrap/Spinner'
import Select from 'react-select'

interface dealerProps {
	show: boolean;
	handleClose: any;
	id: number;
}

interface InitialState {
	idProjects: null | number;
	idCompanies: null | number;
	idDistricts: null | number;
	idUpazilas: null | number;
	dealerName: string;
	issueDate: string;
	dealerId: string;
	ownerName: string;
	binNumber: string;
	tinNumber: string;
	tradeLicenseNumber: string;
	address: string;
	phoneNumber: string;
	nomineeName: string;
	nomineeAddress: string;
	nomineePhoneNumber: string;
	nomineeId: string;
	nomineeRelation: string;
}


const DealerManage: React.FC<dealerProps> = ({ show, handleClose, id }) => {

	const initialState: InitialState = {
		idProjects: null,
		idCompanies: null,
		idDistricts: null,
		idUpazilas: null,
		dealerName: '',
		issueDate: '',
		dealerId: '',
		ownerName: '',
		binNumber: '',
		tinNumber: '',
		tradeLicenseNumber: '',
		address: '',
		phoneNumber: '',
		nomineeName: '',
		nomineeAddress: '',
		nomineePhoneNumber: '',
		nomineeId: '',
		nomineeRelation: '',
		
	};

	const [companies, setCompanies] = useState([]);
	const [company, setCompany] = useState({ label: 'Select Client', value: '' });
	const [projects, setProjects] = useState([]);
	const [project, setProject] = useState({ label: 'Select Project', value: '' });
	const [districts, setDistricts] = useState([]);
	const [district, setDistrict] = useState({ label: 'Select District', value: '' });
	const [upazilas, setUpazilas] = useState([]);
	const [upazila, setUpazila] = useState({ label: 'Select Upazila', value: '' });
	
	const [dealer, setDealer] = useState(initialState);

	useEffect(() => {
		getCompanies();
		getProjects();
		getDistricts();
	}, [])

	useEffect(() => {
		console.log('here', id)
		if (id !== 0) {
			const myToken: string | null = localStorage.getItem('MyToken');
			let jwt: string | null = (myToken != null) ? JSON.parse(myToken) : null;
			fetch(`${process.env.REACT_APP_API_URL}dealer/details/${id}`, {
				headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${jwt}` }
			})
				.then((resp: Response) => {
					return resp.json();
				})
				.then((resp: any) => {
					setDealer(resp);
				})
				.catch((error: any) => {
					
					console.log(error, 'catch the hoop');
				});
		} else {
			setDealer(initialState)
		}
	}, [id]);

	const getCompanies = () => {
		fetch(
			process.env.REACT_APP_API_URL + 'lead/companies',
			getRequestOptions()
		)
			.then((resp) => {
				return resp.json()
			})
			.then((resp) => {
				let companiesObj = resp.data.map((item: any) => {
					item.label = item.name;
					item.value = item.id;
					return item
				})
				setCompanies(companiesObj);
			})
			.catch((error) => {
				console.log(error, 'catch the hoop')
			})
	}
	const getProjects = () => {
		fetch(
			process.env.REACT_APP_API_URL + 'lead/projects',
			getRequestOptions()
		)
			.then((resp) => {
				return resp.json()
			})
			.then((resp) => {
				let projectObj = resp.data.map((item: any) => {
					item.label = item.name;
					item.value = item.id;
					return item
				})
				setProjects(projectObj);
			})
			.catch((error) => {
				console.log(error, 'catch the hoop')
			})
	}

	const getDistricts = () => {
		fetch(
			process.env.REACT_APP_API_URL + 'districts',
			getRequestOptions()
		)
			.then((resp) => {
				return resp.json()
			})
			.then((resp) => {
				
				setDistricts(resp.data);
			})
			.catch((error) => {
				console.log(error, 'catch the hoop')
			})
	}

	useEffect(() => {
	
			if(district.value === ''){
				return ;
			}

			fetch(
				process.env.REACT_APP_API_URL + 'upazilas-by-district/'+district.value,
				getRequestOptions()
			)
				.then((resp) => {
					return resp.json()
				})
				.then((resp) => {
					
					setUpazilas(resp.data);
				})
				.catch((error) => {
					console.log(error, 'catch the hoop')
				})

	}, [district])


	const handleCompanyChange = (comapny: any) => {
		setCompany(comapny);
		setDealer({ ...dealer, idCompanies: comapny?.value });
	}

	const handleProjectChange = (project: any) => {
		setProject(project);
		setDealer({ ...dealer, idProjects: project.value });
	}

	const handleDistrictChange = (district: any) => {
        setDistrict(district);
        setDealer({ ...dealer, idDistricts: district.value });
        setUpazila({ label: 'Select Upazila', value: '' })
    }

    const handleUpazilaChange = (upazila: any) => {
        setUpazila(upazila);
        setDealer({ ...dealer, idUpazilas: upazila.value });
    }



	const [isSubmitDisable, setSubmitDisable] = useState(false);
	const [loading, setLoading] = useState(false);

	const handleChange = (e: any) => {
		setDealer({ ...dealer, [e.target.name]: e.target.value });
	};

	const dealerSave = async (event: any) => {
		event.preventDefault()
		setSubmitDisable(true);
		setLoading(true);
		const confirm = await Swal.fire({
			title: 'Are you sure?',
			text: "You want to create this dealer?",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#ec008c',
			cancelButtonText: 'Cancel',
			confirmButtonText: 'Yes, Submit it!',
		})
		if (confirm.value) {
			const requestOptions = postRequestOptions(dealer)
			try {
				let url = '';
				if (id === 0) {
					url = `${process.env.REACT_APP_API_URL}dealer/create`
				} else {
					url = `${process.env.REACT_APP_API_URL}dealer/update`
				}

				let response = await fetch(
					url,
					requestOptions
				)

				let respData = await response.json()
				if (respData.success === true) {
					const successMsg = respData.successMessage
					Swal.fire({
						icon: 'success',
						title: 'Success',
						text: successMsg,
					})
					handleClose(respData.success)
				} else {
					const errorsMessage = validationErrorMsg(respData.errors).join('<br>')
					Swal.fire({
						icon: 'error',
						title: 'Error',
						html: errorsMessage,
					})
				}
				setSubmitDisable(false);
				setLoading(false);
			} catch (error) {
				setLoading(false);
				console.log(error, 'catch the hoop')
				setSubmitDisable(false);
			}
		}
	}


	return (
		<Modal show={show} onHide={() => handleClose(false)} size="lg">
			<form onSubmit={dealerSave}>
				<Modal.Header closeButton>
					<Modal.Title>
						{id !== 0 ? 'Edit Dealer' : 'Create Dealer'}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					
					<div className="form-group row">
						<label htmlFor="dealerName" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Select Project <span className="required text-danger"></span></label>
						<div className="col-lg-7">
							<Select
							value={project}
							onChange={handleProjectChange}
							options={projects}
							menuPosition="fixed"
						/>
						</div>
					</div>
					<div className="form-group row">
						<label htmlFor="dealerName" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Select Client </label>
						<div className="col-lg-7">
							<Select
							value={company}
							onChange={handleCompanyChange}
							options={companies}
							menuPosition="fixed"
						/>
						</div>
					</div>
					<div className="form-group row">
						<label htmlFor="dealerName" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Select District <span className="required text-danger"></span></label>
						<div className="col-lg-7">
							<Select
							value={district}
							onChange={handleDistrictChange}
							options={districts}
							menuPosition="fixed"
						/>
						</div>
					</div>
					<div className="form-group row">
						<label htmlFor="dealerName" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Select Upazila <span className="required text-danger"></span></label>
						<div className="col-lg-7">
							<Select
							value={upazila}
							onChange={handleUpazilaChange}
							options={upazilas}
							menuPosition="fixed"
						/>
						</div>
					</div>
					<div className="form-group row">
						<label htmlFor="issueDate" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Issue Dae <span className="required text-danger"></span></label>
						<div className="col-lg-7">
							<input type="date" name="issueDate" id="issueDate" value={dealer.issueDate} onChange={handleChange} className="form-control form-control-sm" />
						</div>
					</div>
					<div className="form-group row">
						<label htmlFor="dealerName" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Dealer Name <span className="required text-danger"></span></label>
						<div className="col-lg-7">
							<input type="text" name="dealerName" id="dealerName" value={dealer.dealerName} onChange={handleChange} className="form-control form-control-sm" />
						</div>
					</div>
					<div className="form-group row">
						<label htmlFor="ownerName" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Owner Name <span className="required text-danger"></span></label>
						<div className="col-lg-7">
							<input type="text" name="ownerName" id="ownerName" value={dealer.ownerName} onChange={handleChange} className="form-control form-control-sm" />
						</div>
					</div>
					<div className="form-group row">
						<label htmlFor="binNumber" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>BIN Number <span className="required text-danger"></span></label>
						<div className="col-lg-7">
							<input type="text" name="binNumber" id="binNumber" value={dealer.binNumber} onChange={handleChange} className="form-control form-control-sm" />
						</div>
					</div>
					<div className="form-group row">
						<label htmlFor="tinNumber" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>TIN Number<span className="required text-danger"></span></label>
						<div className="col-lg-7">
							<input type="text" name="tinNumber" id="tinNumber" value={dealer.tinNumber} onChange={handleChange} className="form-control form-control-sm" />
						</div>
					</div>
					<div className="form-group row">
						<label htmlFor="tradeLicenseNumber" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Trade License Number<span className="required text-danger"></span></label>
						<div className="col-lg-7">
							<input type="text" name="tradeLicenseNumber" id="tradeLicenseNumber" value={dealer.tradeLicenseNumber} onChange={handleChange} className="form-control form-control-sm" />
						</div>
					</div>
					<div className="form-group row">
						<label htmlFor="phoneNumber" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Phone<span className="required text-danger"></span></label>
						<div className="col-lg-7">
							<input type="text" name="phoneNumber" id="phoneNumber" value={dealer.phoneNumber} onChange={handleChange} className="form-control form-control-sm" />
						</div>
					</div>
					<div className="form-group row">
						<label htmlFor="address" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Address<span className="required text-danger"></span></label>
						<div className="col-lg-7">
							<textarea name="address" id="address" value={dealer.address} onChange={handleChange} className="form-control form-control-sm" rows={5}></textarea>
						</div>
					</div>
					<div className="form-group row">
						<label htmlFor="nomineeName" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Nominee Name</label>
						<div className="col-lg-7">
							<input type="text" name="nomineeName" id="nomineeName" value={dealer.nomineeName} onChange={handleChange} className="form-control form-control-sm" />
						</div>
					</div>
					<div className="form-group row">
						<label htmlFor="nomineeAddress" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Nominee Address</label>
						<div className="col-lg-7">
							<input type="text" name="nomineeAddress" id="nomineeAddress" value={dealer.nomineeAddress} onChange={handleChange} className="form-control form-control-sm" />
						</div>
					</div>
					<div className="form-group row">
						<label htmlFor="nomineePhoneNumber" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Nominee Phone Number</label>
						<div className="col-lg-7">
							<input type="text" name="nomineePhoneNumber" id="nomineePhoneNumber" value={dealer.nomineePhoneNumber} onChange={handleChange} className="form-control form-control-sm" />
						</div>
					</div>
					<div className="form-group row">
						<label htmlFor="nomineeNid" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Nominee NID</label>
						<div className="col-lg-7">
							<input type="text" name="nomineeNid" id="nomineeNid" value={dealer.nomineeNid} onChange={handleChange} className="form-control form-control-sm" />
						</div>
					</div>
					<div className="form-group row">
						<label htmlFor="nomineeRelation" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Relation with Owner</label>
						<div className="col-lg-7">
							<input type="text" name="nomineeRelation" id="nomineeRelation" value={dealer.nomineeRelation} onChange={handleChange} className="form-control form-control-sm" />
						</div>
					</div>
					
				</Modal.Body>
				<Modal.Footer>

					<button type="submit" disabled={isSubmitDisable || loading} className="btn btn-sm btn-primary me-2">
						{loading &&
							<Spinner
								as="span"
								animation="grow"
								size="sm"
								role="status"
								aria-hidden="true"
							/>
						}
						<span>  Submit</span>
					</button>
					<Button variant='secondary' size="sm" onClick={() => handleClose(false)}>
						Close
					</Button>
				</Modal.Footer>
			</form>
		</Modal>
	)
}

export default DealerManage
